import { Theme } from '@material-ui/core';

export const muiTooltipOverrides = (theme: Theme): Theme['overrides'] => ({
  MuiTooltip: {
    tooltip: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '10px',
      lineHeight: '14px',
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      width: '240px',
      border: `1px ${theme.palette.grey[400]} solid`,
      borderRadius: 0,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(0.5, 1),
    },
  },
});
